module.exports = __webpack_public_path__ + "img/52.e40caa08.jpg";